export default {
    INTERNAL_URL: process.env.INTERNAL_URL || 'https://api.uxreality.com',
    STRIPE_KEY:  process.env.STRIPE_KEY || 'pk_test_qeUBX6Ro1sC12BPOLbvFaPoy'
}